export const BarredLocationsConst = {
  Names: {
    NotAdmitted: 'Not Admitted',
  },
} as const;
